import { ProjectUserRightGeneratedEntity } from "./generated/ProjectUserRightGeneratedEntity";

export abstract class ProjectUserRightEntity extends ProjectUserRightGeneratedEntity {
    // Comment to preserve new line
}
